import { acceptTC } from '../graphql/mutations';
import { getTCAcceptanceStatus, getTCByCountryCode } from '../graphql/queries';
import { makeApiAction } from './actions';

/**
 * Redux action to call and handle the `getTCAcceptanceStatus` query
 * @param {string} countryCode country code of the venue, `"AU"` or `"UK"`
 */
export const fetchTCAcceptanceStatusAction = (countryCode) => (dispatch) => {
  dispatch(
    makeApiAction(
      'FETCH_TC_ACCEPTANCE_STATUS',
      getTCAcceptanceStatus,
      { countryCode },
      {},
      'getTCAcceptanceStatus',
      true,
      dispatch,
    ),
  );
};

/**
 * Redux action to call and handle the `acceptTC` mutation
 * @param {string} countryCode country code of the venue, `"AU"` or `"UK"`
 */
export const acceptTCAction = (countryCode) => (dispatch) => {
  dispatch(makeApiAction('ACCEPT_TC', acceptTC, { countryCode }, {}, 'acceptTC', true, dispatch));
};

/**
 * Redux action to call and handle the `getTCByCountryCode` query
 * @param {string} countryCode country code of the venue, `"AU"` or `"UK"`
 */
export const fetchTCByCountryCodeAction = (countryCode) => (dispatch) => {
  dispatch(
    makeApiAction(
      'FETCH_TC_BY_COUNTRY_CODE',
      getTCByCountryCode,
      { countryCode },
      {},
      'getTCByCountryCode',
      false,
      dispatch,
    ),
  );
};
